// TODO: Fix this the next time the file is edited.
// eslint-disable-next-line import/order
import React, { Component, Fragment } from 'react';
import { Glyphicon } from 'react-bootstrap';
import '../styles/containers/Activities.css';
import '../styles/containers/Promo.css';
// TODO: Fix this the next time the file is edited.
// eslint-disable-next-line import/order
import InfiniteSccroll from 'react-infinite-scroller';
import * as Service from '../services/PromoService';
import PromoList from '../components/promo/PromoList/PromoList';
import TopPanel from '../components/utils/TopPanel';
import Modal from '../components/utils/ModalComponet';
import Spinner from '../components/utils/Spinner';
import TableSortingElem from '../infrastructure/TableSorting';
import PromoFilterForm from '../components/forms/PromoFilterForm';
import {
  getTableSort,
  getTimeWithOffset,
} from '../infrastructure/utils/common';
import { PromoForm } from '../components/forms/PromoForm';
import Succsess from '../components/stateMessage/Succsess';
import Error from '../components/stateMessage/Error';
import { sortParties } from '../infrastructure/utils/promo';
import MobileTopPanelActions from '../components/utils/MobileTopPanelActions';
import MobileListSorter from '../components/utils/MobileListSorter';

class PromoElem {
  name = '';
  startDate = undefined;
  endDate = undefined;
  type = '$';
  value = '';
  start = 0;
  end = 0;
  status = 'active';
}

const initialState = {
  promoLoaded: false,
  allPromo: false,
  isDeactive: false,
  activePromo: false,
  openModal: false,
  modalContent: () => '',
  promoForm: false,
  noData: false,
  activeSort: null,
  filterData: undefined,
  avaliableSort: [
    new TableSortingElem({ name: 'name', isString: true, up: true }),
    new TableSortingElem({ name: 'name', isString: true, up: false }),
    new TableSortingElem({ name: 'startDate', up: true, label: 'Start Date' }),
    new TableSortingElem({ name: 'startDate', up: false, label: 'Start Date' }),
    new TableSortingElem({ name: 'status', isString: true, up: true }),
    new TableSortingElem({ name: 'status', isString: true, up: false }),
  ],
  promo: null,
  searchedPromo: null,
  filter: 'all',
  isError: false,
  token: null,
  firstLoad: true,
  isMobileFilterSelected: false,
  isMobileSortSelected: false,
};

export class Promo extends Component {
  constructor(props) {
    super(props);
    this.state = initialState;
  }

  async componentDidMount() {
    document.documentElement.style.overflow = 'hidden';
    // TODO: (fix build workaround) Need to be fixed next time when this code will be changed
    // @ts-ignore
    this.loadFirstPromo();
  }

  componentWillUnmount() {
    document.documentElement.style.overflow = 'auto';
    this.setState({ deactive: true });
  }

  loadFirstPromo = async filterData => {
    this.loadPromo({
      token: 0,
      firstLoad: true,
      order: new TableSortingElem({ name: 'name', isString: true }),
      // TODO: (fix build workaround) Need to be fixed next time when this code will be changed
      // @ts-ignore
      filterData,
    });
  };

  closeModal = () => {
    this.setState({ openModal: false });
  };

  hideMessage = () => {
    this.setState({ isSuccsess: false, isError: false });
  };

  succsess = text => {
    this.setState({ isSuccsess: true, successText: text });
    setTimeout(this.hideMessage, 5000);
  };

  error = text => {
    this.setState({ isError: true, errorText: text });
    setTimeout(this.hideMessage, 5000);
  };

  removeFilter = () => {
    // TODO: (fix build workaround) Need to be fixed next time when this code will be changed
    // @ts-ignore
    const { searchedPromo } = this.state;
    this.setState({ filterData: undefined, promo: searchedPromo });
  };

  createNewPromo = () => {
    this.setState({
      openModal: true,
      modalContent: this.renderPromoForm,
      activePromo: undefined,
    });
  };

  handlePromoClick = promoId => {
    // TODO: (fix build workaround) Need to be fixed next time when this code will be changed
    // @ts-ignore
    const { promo } = this.state;
    const item = promo.find(it => it.name === promoId);
    this.setState({
      openModal: true,
      modalContent: this.renderPromoForm,
      activePromo: item,
    });
  };

  getFilteredPromo = async filterData => {
    this.setState({ filterData, promo: this.filter(filterData) });
  };

  filter = filterData => {
    // TODO: (fix build workaround) Need to be fixed next time when this code will be changed
    // @ts-ignore
    const { searchedPromo } = this.state;
    let result = searchedPromo;
    if (filterData.fromDate !== undefined && filterData.fromDate !== '') {
      result = result.filter(elem => {
        if (elem.startDate !== undefined && elem.startDate !== '') {
          const start = getTimeWithOffset(elem.startDate);
          // TODO: (fix build workaround) Need to be fixed next time when this code will be changed
          // @ts-ignore
          start.setHours(0);
          // TODO: (fix build workaround) Need to be fixed next time when this code will be changed
          // @ts-ignore
          start.setMinutes(0);
          const end = getTimeWithOffset(elem.endDate);
          // TODO: (fix build workaround) Need to be fixed next time when this code will be changed
          // @ts-ignore
          end.setHours(23);
          // TODO: (fix build workaround) Need to be fixed next time when this code will be changed
          // @ts-ignore
          end.setMinutes(59);
          // TODO: (fix build workaround) Need to be fixed next time when this code will be changed
          // @ts-ignore
          return start <= filterData.fromDate && filterData.fromDate <= end;
        }
        return false;
      });
    }
    if (filterData.active) {
      result = result.filter(elem => elem.status === 'active');
    }
    if (filterData.name.length > 0) {
      result = result.filter(
        elem =>
          elem.name.toLowerCase().indexOf(filterData.name.toLowerCase()) > -1
      );
    }
    return result;
  };

  handleCreatePromoSubmit = async (newPromo, addElse = false) => {
    // TODO: (fix build workaround) Need to be fixed next time when this code will be changed
    // @ts-ignore
    const { searchedPromo } = this.state;
    await Service.createPromo(newPromo);
    if (!addElse) {
      this.setState({ openModal: false, promo: searchedPromo });
    } else {
      this.setState({ openModal: true, activePromo: new PromoElem() });
    }
    // TODO: (fix build workaround) Need to be fixed next time when this code will be changed
    // @ts-ignore
    this.loadFirstPromo();
  };

  handleUpdatePromoSubmit = async (newPromo, closeForm = true) => {
    // TODO: (fix build workaround) Need to be fixed next time when this code will be changed
    // @ts-ignore
    const { searchedPromo } = this.state;
    await Service.updatePromo(newPromo);
    if (closeForm) {
      this.setState({ openModal: false, promo: searchedPromo });
    }
    // TODO: (fix build workaround) Need to be fixed next time when this code will be changed
    // @ts-ignore
    this.loadFirstPromo();
  };

  loadPromo = async ({ token, firstLoad, order }) => {
    const data = await Service.getAllPromo(token);
    if (data.length === 0) {
      if (firstLoad) {
        this.setState({ promo: [] });
      }
      this.setState({ allPromo: true, promoLoaded: true });
      return;
    }
    // TODO: (fix build workaround) Need to be fixed next time when this code will be changed
    // @ts-ignore
    const { deactive } = this.state;
    if (!deactive) {
      if (firstLoad) {
        this.setState({
          promo: sortParties(data, order),
          searchedPromo: data,
          activeSort: order,
          allPromo: true,
          promoLoaded: true,
        });
      } else {
        this.setState(state => ({
          // TODO: (fix build workaround) Need to be fixed next time when this code will be changed
          // @ts-ignore
          activities: state.activities.concat(data),
          // TODO: (fix build workaround) Need to be fixed next time when this code will be changed
          // @ts-ignore
          token: state.token + 25,
        }));
      }
    }
  };

  renderPromoForm = () => {
    // TODO: (fix build workaround) Need to be fixed next time when this code will be changed
    // @ts-ignore
    const { activePromo, isError } = this.state;
    return (
      <PromoForm
        // TODO: (fix build workaround) Need to be fixed next time when this code will be changed
        // @ts-ignore
        back={this.backFromForm}
        isError={isError}
        promo={activePromo}
        succsess={this.succsess}
        error={this.error}
        handleCreatePromoSubmit={this.handleCreatePromoSubmit}
        handleUpdatePromoSubmit={this.handleUpdatePromoSubmit}
        // TODO: (fix build workaround) Need to be fixed next time when this code will be changed
        // @ts-ignore
        deletePromo={this.deletePromo}
      />
    );
  };

  changeSort = name => {
    // TODO: (fix build workaround) Need to be fixed next time when this code will be changed
    // @ts-ignore
    const { activeSort, avaliableSort, promo } = this.state;
    const sort = getTableSort(name, activeSort, avaliableSort);
    this.setState(prev => ({
      ...prev,
      promo: sortParties(promo, sort),
      activeSort: sort,
    }));
  };

  changeSortBySelect = (name, up) => {
    // TODO: (fix build workaround) Need to be fixed next time when this code will be changed
    // @ts-ignore
    const { avaliableSort, promo } = this.state;
    const sort = avaliableSort.find(s => s.name === name);
    if (!sort) return;
    const sortCopy = { ...sort };
    sortCopy.up = up;
    this.setState(prev => ({
      ...prev,
      promo: sortParties(promo, sortCopy),
      activeSort: sortCopy,
    }));
  };

  render() {
    const {
      // TODO: (fix build workaround) Need to be fixed next time when this code will be changed
      // @ts-ignore
      promoLoaded,
      // TODO: (fix build workaround) Need to be fixed next time when this code will be changed
      // @ts-ignore
      activeSort,
      // TODO: (fix build workaround) Need to be fixed next time when this code will be changed
      // @ts-ignore
      promo,
      // TODO: (fix build workaround) Need to be fixed next time when this code will be changed
      // @ts-ignore
      isSuccsess,
      // TODO: (fix build workaround) Need to be fixed next time when this code will be changed
      // @ts-ignore
      isError,
      // TODO: (fix build workaround) Need to be fixed next time when this code will be changed
      // @ts-ignore
      successText,
      // TODO: (fix build workaround) Need to be fixed next time when this code will be changed
      // @ts-ignore
      errorText,
      // TODO: (fix build workaround) Need to be fixed next time when this code will be changed
      // @ts-ignore
      allPromo,
      // TODO: (fix build workaround) Need to be fixed next time when this code will be changed
      // @ts-ignore
      openModal,
      // TODO: (fix build workaround) Need to be fixed next time when this code will be changed
      // @ts-ignore
      modalContent,
      // TODO: (fix build workaround) Need to be fixed next time when this code will be changed
      // @ts-ignore
      filterData,
      // TODO: (fix build workaround) Need to be fixed next time when this code will be changed
      // @ts-ignore
      isMobileFilterSelected,
      // TODO: (fix build workaround) Need to be fixed next time when this code will be changed
      // @ts-ignore
      isMobileSortSelected,
      // TODO: (fix build workaround) Need to be fixed next time when this code will be changed
      // @ts-ignore
      avaliableSort,
    } = this.state;
    if (!promoLoaded) {
      return <Spinner />;
    }
    return (
      <Fragment>
        {isSuccsess && <Succsess text={successText} />}
        {isError && <Error text={errorText} />}
        <Modal
          open={openModal}
          closeModal={this.closeModal}
          cancel={this.closeModal}
        >
          {modalContent()}
        </Modal>
        <TopPanel>
          <h1 style={{ marginTop: '0px' }}>
            <span className='fas fa-beer' />
            Promo codes
          </h1>
          <button
            type='button'
            className='add-promo-mobile-button'
            onClick={this.createNewPromo}
          >
            <i className='fa fa-plus-circle' />
          </button>
          {
            // TODO: (fix build workaround) Need to be fixed next time when this code will be changed
            // @ts-ignore
            <MobileTopPanelActions
              isFilterSelected={isMobileFilterSelected}
              isSortSelected={isMobileSortSelected}
              onFilterClick={() =>
                this.setState({
                  isMobileFilterSelected: !isMobileFilterSelected,
                })
              }
              onSortClick={() =>
                this.setState({ isMobileSortSelected: !isMobileSortSelected })
              }
            />
          }
        </TopPanel>
        <div className='data-container'>
          <PromoFilterForm
            // TODO: (fix build workaround) Need to be fixed next time when this code will be changed
            // @ts-ignore
            filterPromo={this.getFilteredPromo}
            filteredData={filterData}
            clear={this.removeFilter}
            isMobileFilterSelected={isMobileFilterSelected}
          />
          <MobileListSorter
            isSortSelected={isMobileSortSelected}
            activeSort={activeSort}
            availableSort={avaliableSort}
            changeSortBySelect={this.changeSortBySelect}
          />
          <button
            type='button'
            className='btn btn-primary pull-right panel-button add-promo-button'
            onClick={this.createNewPromo}
            style={{ marginRight: '30px' }}
          >
            + Add New
          </button>
          <div className='clearfix' />
          {promo.length !== 0 ? (
            <div key='111' className='table-box tab-cont small-height'>
              <InfiniteSccroll
                pageStart={0}
                loadMore={() => []}
                hasMore={!allPromo}
                loader={
                  <Glyphicon key={0} glyph='refresh' className='spinning' />
                }
              >
                <PromoList
                  promo={promo}
                  changeSort={this.changeSort}
                  activeSort={activeSort}
                  handleOnClick={this.handlePromoClick}
                />
              </InfiniteSccroll>
            </div>
          ) : (
            <h2>Promo codes list is empty</h2>
          )}
        </div>
      </Fragment>
    );
  }
}
